import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import { FileText, Loader2 } from "lucide-react";

export const FicSettingsCard = () => {
  const [cfg, setCfg] = useState(null);
  const [form, setForm] = useState({ client_id: "", client_secret: "", redirect_uri: "" });
  const [busy, setBusy] = useState(false);
  const apply = (d) => { setCfg(d); setForm({ client_id: "", client_secret: "", redirect_uri: d.redirect_uri || "" }); };
  useEffect(() => { api.get("/admin/fic/settings").then((r) => apply(r.data)).catch(() => {}); }, []);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/admin/fic/settings", form); apply(data); toast.success("Impostazioni Fatture in Cloud salvate. Se hai cambiato i token, premi Ricollega."); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Salvataggio non riuscito"); }
    finally { setBusy(false); }
  };
  const disconnect = async () => {
    if (!window.confirm("Scollegare Fatture in Cloud? Dovrai ricollegarlo da qui.")) return;
    await api.post("/admin/fic/disconnect"); const { data } = await api.get("/admin/fic/settings"); apply(data); toast.success("Fatture in Cloud scollegato. Premi Collega per autorizzarlo di nuovo.");
  };
  const connect = async () => {
    setBusy(true);
    try { const { data } = await api.get("/admin/fic/connect", { params: { redirect_uri: `${window.location.origin}/app/fatture` } }); window.location.assign(data.url); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Collegamento non disponibile"); setBusy(false); }
  };
  if (!cfg) return null;
  const suggested = `${window.location.origin}/app/fatture`;
  return (
    <Card className="p-6 glow-border space-y-4" data-testid="fic-settings-card">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-lg bg-primary/15 text-primary flex items-center justify-center"><FileText className="w-5 h-5" /></div>
        <div><h2 className="font-head text-lg font-semibold">Fatture in Cloud</h2><p className="text-xs text-muted-foreground">Token dell'app e URL di ritorno per il collegamento.</p></div>
        <Badge className={`ml-auto ${cfg.connected ? "bg-teal-600 hover:bg-teal-600" : ""}`} variant={cfg.connected ? "default" : "outline"} data-testid="fic-settings-status">{cfg.connected ? `Collegato${cfg.company_name ? ` · ${cfg.company_name}` : ""}` : "Non collegato"}</Badge>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <div className="space-y-1.5"><Label>Client ID</Label><Input value={form.client_id} onChange={(e) => setForm({ ...form, client_id: e.target.value })} placeholder={cfg.client_id_set ? `Impostato (${cfg.client_id_hint}) — lascia vuoto per non cambiarlo` : "Incolla il Client ID"} data-testid="fic-client-id-input" /></div>
        <div className="space-y-1.5"><Label>Client Secret</Label><Input type="password" autoComplete="new-password" value={form.client_secret} onChange={(e) => setForm({ ...form, client_secret: e.target.value })} placeholder={cfg.client_secret_set ? "Impostato — lascia vuoto per non cambiarlo" : "Incolla il Client Secret"} data-testid="fic-client-secret-input" /></div>
      </div>
      <div className="space-y-1.5">
        <Label>URL di ritorno (Redirect URL)</Label>
        <Input value={form.redirect_uri} onChange={(e) => setForm({ ...form, redirect_uri: e.target.value })} placeholder={suggested} data-testid="fic-redirect-input" />
        <p className="text-[11px] text-muted-foreground">Deve essere identica a quella inserita nell'app su Fatture in Cloud. Se vuota uso <span className="font-mono">{suggested}</span>.</p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button onClick={save} disabled={busy} data-testid="fic-settings-save">{busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Salva</Button>
        {cfg.client_id_set && cfg.client_secret_set && <Button variant="outline" onClick={connect} disabled={busy} data-testid="fic-settings-connect">{cfg.connected ? "Ricollega (nuove autorizzazioni)" : "Collega Fatture in Cloud"}</Button>}
        {cfg.connected && <Button variant="outline" onClick={disconnect} data-testid="fic-disconnect">Scollega</Button>}
      </div>
    </Card>
  );
};
